import { useEffect, useState } from 'react'
import _isEmpty from 'lodash/isEmpty';
import compose from 'recompose/compose';
import useGiftsData from 'newHooks/useGiftsData';

import { resetGifts } from 'store/actions/gifts/actions';

import useAnteaterData from 'newHooks/useAnteaterData';
import useAlgoliaData from 'newHooks/useAlgoliaData';

import { withAgentPage, withLayout } from 'hocs';

import ClosedTableMessage from 'components/gifts-table/ClosedTableMessage';

// import CategoryModule from 'newComponents/categoryModule';
import GridProductResult from 'newComponents/gridProduct';
import FilterModule from 'newComponents/filterModule';
import ContentSearch from 'newComponents/ContTitleSearch';
import ProductAddTable from 'newComponents/ProductsModal/ProductAddTable';
import GiftsHeader from 'newComponents/GiftsHeader/GiftsHeaderNavigate';
import styles from './styles.module.sass';
import CategoryModule from 'newComponents/categoryModule';


/* /Mesa-de-Regalos/agregar-regalos */
function AddGifts() {
  
    const {giftTable, dispatch} = useGiftsData()
    const [ , setResponseTable ] = useState(null)
    const [ , setTotal ] = useState(null)
    const [ , setIsEmpty ] = useState(null)

    // const { getAnteater: getSearch, resultsSearch, filters } = useAnteaterData()
    const { getAlgolia: getSearch, resultsSearch, filters } = useAlgoliaData()

    const initialCat = {
        nameCategory: 'Muebles',
        idCategory: 4496
    }

    const cateEvents = [
        { event: 'Boda', initialCat: { nameCategory: 'Muebles', idCategory: 4496 } },
        { event: 'Aniversario', initialCat: { nameCategory: 'Hogar', idCategory: 4497 } },
        { event: 'Primera Comunión', initialCat: { nameCategory: 'Niñas y Niños', idCategory: 17111 } },
        { event: 'Despedidas', initialCat: { nameCategory: 'Hogar', idCategory: 4497 } },
        { event: 'Open House', initialCat: { nameCategory: 'Hogar', idCategory: 4497 } },
        { event: 'Casa Nueva', initialCat: { nameCategory: 'Hogar', idCategory: 4497 } },
        { event: 'Bautizo', initialCat: { nameCategory: 'Niñas y Niños', idCategory: 17111 } },
        { event: 'Cumpleaños Adulto', initialCat: { nameCategory: 'Electrónica y Tecnología', idCategory: 4499 } },
        { event: 'Cumpleaños Niño', initialCat: { nameCategory: 'Niñas y Niños', idCategory: 17111 } },
        { event: 'Cumpleaños Infantil', initialCat: { nameCategory: 'Niñas y Niños', idCategory: 17111 } },
        { event: 'Baby Shower', initialCat: { nameCategory: 'Mamá y Bebé', idCategory: 4502 } },
        { event: 'XV Años', initialCat: { nameCategory: 'Electrónica y Tecnología', idCategory: 4499 } },
        { event: 'Graduación', initialCat: { nameCategory: 'Muebles', idCategory: 4496 } }
    ]

    const initFilters = {
        reviews: false,
        hasFree: false,
        fullfilment: false,
        brands: [],
        categories: [],
        discounts: {},
        rangePrice: {}
    }
    
    const [ tableStatus, setTableStatus ] = useState('')
    const [ wordToSearch, setWordToSearch ] = useState(null)
    const [ page, setPage ] = useState(null)
    const [ order, setOrder ] = useState(null)
    const [ filtersActive, setFiltersActive ] = useState(null)
    const [ resetFilters, setResetFilters ] = useState(null)
    const [ tableOpen, setTableOpen ] = useState(false)
    const [ categorySelected, setCategorySelected ] = useState(null)
    const [ activeView, setActiveView ] = useState('mosaico')

    useEffect(()=>{
        if(!_isEmpty(giftTable)){
            if(giftTable?.id){
                // getSearch({initial: initialCat, nameComp: 'initID', typeInit: 'category'})
                if(giftTable?.type?.name || giftTable?.tipo){
                    const catName = giftTable?.type?.name || giftTable?.tipo
                    const categoryPerEvent = cateEvents.find(category => category?.event === catName ) || initialCat
                    // console.log('categoryPerEvent: ',categoryPerEvent)
                    getSearch({initial: categoryPerEvent?.initialCat, nameComp: 'initID', typeInit: 'category'})
                    // getSearch({initial: (giftTable?.type?.name || giftTable?.tipo), nameComp: 'initID', typeInit: 'search'})
                }
            }
        }
    },[giftTable?.id])

    useEffect(()=>{
        if(wordToSearch){
            getSearch({ searchWord: wordToSearch, category: categorySelected || initialCat, pagination: 1, aplicateFilters: initFilters, orderBy: order, nameComp: 'search' })
            setResetFilters(true)
            setPage(1)
        }
    },[wordToSearch])
    
    useEffect(()=>{
        if(categorySelected){
            getSearch({ searchWord: '', category: categorySelected || initialCat, pagination: 1, aplicateFilters: initFilters, orderBy: order, nameComp: 'categorySelected' })
            setResetFilters(true)
            setWordToSearch(null)
            setPage(1)
        }
    },[categorySelected])
    
    useEffect(()=>{
        if(page){
            window.scrollTo(0, 0)
            getSearch({ searchWord: wordToSearch, category: categorySelected || initialCat, pagination: page, aplicateFilters: filtersActive, orderBy: order, nameComp: 'page' })
        }
    },[page])

    useEffect(()=>{
        if(order){
            getSearch({ searchWord: wordToSearch, category: categorySelected || initialCat, pagination: page, aplicateFilters: filtersActive, orderBy: order, nameComp: 'order' })
        }
    },[order])
    
    useEffect(()=>{
        // console.log('resetFilters: ', resetFilters)
        if(!resetFilters){
            // console.log('filtersActive efect: ', filtersActive)
            if(filtersActive){
                getSearch({ searchWord: wordToSearch, category: categorySelected || initialCat, pagination: 1, aplicateFilters: filtersActive, orderBy: order, nameComp: 'filtersActive' })
                setPage(1)
            }
        }else{
            setFiltersActive(null)
            setResetFilters(null)
        }
    },[filtersActive, resetFilters])
  
    useEffect(() => {
        if (!_isEmpty(giftTable)) {
            setTableStatus(giftTable?.estatus || giftTable?.status);
            setTableOpen(tableStatus === 'Open');
        }
    }, [giftTable, tableStatus]);


    useEffect(() => () => dispatch(resetGifts()), []);

  return (
    <>
        <GiftsHeader
            setResponseTable={setResponseTable}
            setTotal={setTotal}
            setIsEmpty={setIsEmpty}
        />
        <div className={styles?.externalContainer}>

            <div className={styles?.container} >
                {tableOpen 
                    ?
                        <div>
                            {/* <CategoryModule
                                setCategorySelected={setCategorySelected}
                                initialCat={initialCat}
                            /> */}

                            <ProductAddTable />

                            <ContentSearch 
                                setSearchWord={setWordToSearch}
                                setActiveView={setActiveView}
                                resultsSearch={resultsSearch}
                                setOrder={setOrder}
                            />

                            <div className={styles?.contentGrid}>

                                <FilterModule 
                                    filters={filters}
                                    initFilters={initFilters}
                                    setFiltersActive={setFiltersActive}
                                    resetFilters={resetFilters}
                                    setResetFilters={setResetFilters}
                                />

                                <GridProductResult
                                    resultsSearch={resultsSearch}
                                    setPage={setPage}
                                    activeView={activeView}
                                    page={page}
                                />

                            </div>
                        </div>
                    :
                        <div className="mb-5">
                            <ClosedTableMessage />
                        </div>
                }
            </div>
        </div>
    </>
  );
}

export default compose(
    withLayout,
    withAgentPage({ fetchTableInfo: true })
)(AddGifts);
